import { useState } from "react";
import styled from "styled-components";

/* 
  CSS PROPERTIES
  apperance : display an element using a platform-native styling based on the users’ operating system’s theme.
  will-change: helps browser take better decisions when a element changes properties. Increased optimization for css animations
  touch-action = mainpulation : disables double tap to zoom feature on mobile devices,removes the need for browsers to delay the generation of click events when the user taps the screen
*/

const StyledButton = styled.button`
	user-select: none;
	font-family: Raleway, sans-serif;
	font-weight: 500;
	align-items: center;
	appearance: none;
	background-color: rgba(45, 35, 66, 0.8);
	border-radius: ${(props) => props.borderRadius};
	border-width: 0;
	box-sizing: border-box;
	color: #fff;
	cursor: pointer;
	display: inline-flex;
	height: ${(props) => props.height};
	justify-content: center;
	line-height: 1;
	list-style: none;
	overflow: hidden;
	position: relative;
	text-align: left;
	text-decoration: none;
	transition: box-shadow 0.15s, transform 0.15s;
	user-select: none;
	-webkit-user-select: none;
	touch-action: manipulation;
	white-space: nowrap;
	will-change: box-shadow, transform;
	font-size: 16px;
	margin: ${(props) => props.margin};
	width: ${(props) => props.width};
	padding: ${(props) => props.padding};
	&:hover {
		transform: translateY(-2px);
	}
	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
`;

StyledButton.defaultProps = {
	width: "max-content",
	borderRadius: "4px",
	padding: "0.3rem 0.8rem",
	height: "48px",
};

const Button = ({ loading, disabled, children, onClick, ...rest }) => {
	const [isLoading, setIsLoading] = useState(false);

	const isDisabled = disabled || isLoading;

	const handleClick = async () => {
		if (!onClick) return;
		// Check if the handler is an async function
		const isAsync = onClick.constructor.name === "AsyncFunction";

		if (isAsync) {
			setIsLoading(true);
			try {
				await onClick();
			} finally {
				setIsLoading(false);
			}
		} else {
			onClick();
		}
	};

	return (
		<StyledButton onClick={handleClick} disabled={isDisabled} {...rest}>
			{children}
		</StyledButton>
	);
};

export default Button;
